import {
  ClerkProvider,
  SignedIn,
  SignedOut,
} from "@clerk/clerk-react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { RecommendationToasts } from "./components/recommendations/RecommendationToast";
import { AddQuestions } from "./pages/AddQuestions";
import { AgentDashboard } from "./pages/AgentDashboard";
import { Attempts } from "./pages/Attempts";
import { CreateQuiz } from "./pages/CreateQuiz";
import { Dashboard } from "./pages/Dashboard";
import { Landing } from "./pages/Landing";
import { Onboarding } from "./pages/Onboarding";
import { PlayerScreen } from "./pages/PlayerScreen";
import { Quizes } from "./pages/Quizes";
import { QuizResponse } from "./pages/QuizResponse";
import { SignInPage } from "./pages/SignIn";
import SignUpPage from "./pages/Signup";
import { TraceRun } from "./pages/TraceRun";
import { Traces } from "./pages/Traces";
import { StatisticsAllQuestions } from "./pages/stats/StatisticsAllQuestions";
import { StatisticsByQuiz } from "./pages/stats/StatisticsByQuiz";
import { StatisticsByQuizQuestionsId } from "./pages/stats/StatisticsByQuizQuestionsId";
import { UpdateQuestion } from "./pages/UpdateQuestion";
import { UpdateQuiz } from "./pages/UpdateQuiz";
import { UserProfilePage } from "./pages/UserProfile";

function App() {
  const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
  const navigate = useNavigate();

  if (!publishableKey) {
    throw new Error("Missing REACT_APP_CLERK_PUBLISHABLE_KEY");
  }

  return (
    <ClerkProvider
      afterSignOutUrl="/"
      publishableKey={publishableKey}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
    >
      <Layout>
        <SignedIn>
          <Routes>
            <Route path="/quizes" element={<Quizes />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/attempts" element={<Attempts />} />
            <Route
              path="/dashboard/attempts/:attemptId"
              element={<QuizResponse />}
            />
            <Route
              path="/statistics/quiz/:quizId"
              element={<StatisticsByQuiz />}
            />
            <Route
              path="/statistics/:quizId/questions/:questionId"
              element={<StatisticsByQuizQuestionsId />}
            />
            <Route
              path="/statistics/:quizId/questions"
              element={<StatisticsAllQuestions />}
            />
            <Route path="/quizes/add" element={<CreateQuiz />} />
            <Route path="/quizes/:id" element={<PlayerScreen />} />
            <Route path="/quizes/:id/update" element={<UpdateQuiz />} />
            <Route path="/quizes/:id/questions" element={<AddQuestions />} />
            <Route
              path="/quizes/:quizId/questions/:questionId"
              element={<UpdateQuestion />}
            />
            <Route path="/user" element={<UserProfilePage />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/agent" element={<AgentDashboard />} />
            <Route path="/traces" element={<Traces />} />
            <Route path="/traces/:runId" element={<TraceRun />} />
            <Route path="/" element={<Navigate replace to="/quizes" />} />
          </Routes>
          <RecommendationToasts />
        </SignedIn>
        <SignedOut>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/sign-up" element={<SignUpPage />} />
            <Route path="/sign-in" element={<SignInPage />} />
            <Route path="*" element={<Navigate replace to="/" />} />
            {/* <Route path="*" element={<RedirectToSignUp />} /> */}
          </Routes>
        </SignedOut>
      </Layout>
    </ClerkProvider>
  );
}

export default App;
